/**
 * 作业预览
 */

import MockPath from '@/mock/mock_api';
import axios from 'axios';
import { cloneDeep } from '@/lib';
import { IJobModuleQuestionJson, IJobModuleQuestionParse } from '../../addJob/js/interface';
import { parseData } from '../../addJob/question/js';

const mockPath = new MockPath();

/** api获得 modules-questions */
export const getPreviewData = async (analysisId = 'id') => {
  try {
    const { data } = await axios.post(mockPath.getPreviewData, analysisId);
    return data;
  } catch (error) {
    console.log(error);
    return {};
  }
};

/** 将json格式的question转为array */
export const transQuestionData = (data: IJobModuleQuestionJson[]): IJobModuleQuestionParse[] => {
  const res = cloneDeep(data);
  const newArr = data.map((module) => {
    const questionList = module.questionList.map((question) => parseData(question));
    return { ...module, questionList };
  });
  console.log(res, newArr, 'this is questions data');
  // return data;
  return newArr;
};

export const t = '站空';
